import { ColumnName } from "../enums/column-name";
import { TAssetUsageRecordsConfigurationState } from "../interfaces/asset-usage-records-state";

import { assetUsageRecordColumnLabels } from "./asset-usage-record-column-labels";

export function getConfigurationState(): TAssetUsageRecordsConfigurationState {
  return {
    columns: assetUsageRecordColumnLabels,
    // initially visible columns (if one of them isn't presended in configurable array, then it will be persistent)
    selected: Object.values(ColumnName).filter(
      // Изначально скрываем столбцы "Комментарий" и "Пользователь"
      (columnName) =>
        columnName !== ColumnName.Comment && columnName !== ColumnName.PersonCreatedName
    ),
    configurable: [
      ColumnName.PersonCreatedName,
      ColumnName.PersonResponsibleName,
      ColumnName.Norma,
      ColumnName.CropTypeName,
      ColumnName.Comment,
    ],
  };
}
